<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        var favicon = 'favicon.ico'
        if (to.path.indexOf('/hongqi') === 0) favicon = 'favicon_hongqi.ico'
        else if (to.path.indexOf('/zeekr') === 0) favicon = 'favicon_zeekr.ico'
        else if (to.path.indexOf('/icaur') === 0) favicon = 'favicon_icaur.ico'
        var el = document.getElementById('dynamic-favicon')
        if (el) el.href = favicon
      },
    },
  },
}
</script>
